export const getAgreements = () => {
  return {
    agreementTitles: [],
    agreementURLs: [],
  };
};

const SOAConfig = {
  getAgreements,
};

export default SOAConfig;
